module.exports = __webpack_public_path__ + "static/media/prep-cuts.400ff144.png";